/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskReportsWorkloadRoute } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskReportsWorkloadRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import WorkloadReports, { LazyServicedeskReportsWorkload } from './ui/workload/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskReportsWorkloadRouteEntry: Route = createEntry(
	servicedeskReportsWorkloadRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: WorkloadReports,
		perfMetricKey: 'service-management.reports.workload',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskReportsWorkload],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
